/**
 *  Liste des constantes du module
 */

export const CANNOT_DELETE_TRAITMENT_ERROR_MESSAGE = "Le traitement ne peut pas être supprimé car il y a des séances validées."
